module.exports = __webpack_public_path__ + "static/img/img_14.a156dc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_14.jpg
// module id = 187
// module chunks = 20